import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'

// Styled components
const StyledTableContainer = styled(TableContainer)({
  fontFamily: 'Poppins, sans-serif'
})

const StyledTableCell = styled(TableCell)({
  fontFamily: 'Poppins, sans-serif'
})

const JsonDataRenderer = ({ jsonData }) => {
  return (
    <StyledTableContainer component={Paper}>
      <Table>
        {/* <TableHead sx={{ backgroundColor: '#EEEEEE' }}>
          <TableRow>
            <StyledTableCell>
              <strong>Key</strong>
            </StyledTableCell>
            <StyledTableCell>
              <strong>Value</strong>
            </StyledTableCell>
          </TableRow>
        </TableHead> */}
        <TableBody>
          {jsonData?.message?.error?.error && (
            <TableRow style={{ backgroundColor: '#FFCCCC' }}>
              <StyledTableCell>Error</StyledTableCell>
              <StyledTableCell>{jsonData?.message?.error?.error}</StyledTableCell>
            </TableRow>
          )}

          {jsonData?.status && (
            <TableRow
              style={{ backgroundColor: jsonData.status?.toLowerCase() === 'failed' ? '#FFCCCC' : '#b7c8b3' }}
            >
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>{jsonData.status}</StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </StyledTableContainer>
  )
}

export default JsonDataRenderer
